export default __webpack_public_path__ + "static/media/20200822-IMG_0037.47b76b31.webp";